import { render, staticRenderFns } from "./editor_text.vue?vue&type=template&id=239d7148"
import script from "./editor_text.vue?vue&type=script&lang=js"
export * from "./editor_text.vue?vue&type=script&lang=js"
import style0 from "./editor_text.vue?vue&type=style&index=0&id=239d7148&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports